<script setup>
import { computed } from 'vue';

const $props = defineProps({
    width: {
        type: [String, Number],
        default: undefined
    },
    height: {
        type: [String, Number],
        default: undefined
    },
    inverted: {
        type: Boolean,
        default: false
    },
    lazyLoad: {
        type: Boolean,
        default: false
    }
});

const computedWidth = computed(() => !$props.width && !$props.height ? '243px' : normalizeDimension($props.width || 'auto')),
    computedHeight = computed(() => !$props.height && $props.width ? '40px' : normalizeDimension($props.height || 'auto')),
    attrWidth = computed(() => stripPxSuffix(computedWidth.value)),
    attrHeight = computed(() => stripPxSuffix(computedHeight.value));

function normalizeDimension(value) {
    return typeof value === 'number' ? `${value}px` : value;
}

function stripPxSuffix(value) {
    return typeof value === 'number' ? value : parseInt(value, 10) || undefined;
}
</script>

<template>
    <div class="app-logo">
        <router-link to="/" aria-label="Go to Xprt Jobs">
            <img
                v-if="inverted"
                :loading="lazyLoad ? 'lazy' : undefined"
                src="~assets/xprt-jobs-logo-white.svg"
                alt="Xprt Jobs Logo"
                :width="attrWidth"
                :height="attrHeight"
            />
            <img
                v-else
                :loading="lazyLoad ? 'lazy' : undefined"
                src="~assets/xprt-jobs-logo.svg"
                alt="Xprt Jobs Logo"
                :width="attrWidth"
                :height="attrHeight"
            />
        </router-link>
    </div>
</template>

<style scoped lang="scss">
.app-logo {
    width: v-bind(computedWidth);
    height: v-bind(computedHeight);
    line-height: 0;

    a {
        display: block;
        line-height: 0;
        white-space: nowrap;
    }

    img {
        height: 100%;
        max-height: 100%;
        max-width: 100%;
        object-fit: contain;
        width: 100%;
    }
}
</style>
